
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bewerten",
      function () {
        return require("private-next-pages/bewerten/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bewerten"])
      });
    }
  